import { useMemo, useState } from "react";
import "./HistorialTab.css";

export default function HistorialTab() {

    const [search, setSearch] = useState("");

    // Aquí vendrá la API
    const campaigns = [];

    const filtered = useMemo(() => {

        if (!search.trim()) return campaigns;

        return campaigns.filter(c =>
            c.subject.toLowerCase().includes(search.toLowerCase())
        );

    }, [campaigns, search]);

    return (

        <div className="history-page">

            <div className="history-toolbar">

                <div className="history-search">

                    <i className="fa-solid fa-magnifying-glass"></i>

                    <input
                        placeholder="Buscar campaña..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                </div>

                <button className="history-refresh">

                    <i className="fa-solid fa-rotate"></i>

                    Actualizar

                </button>

            </div>

            <div className="history-table">

                <div className="history-head">

                    <div>Asunto</div>

                    <div>Fecha</div>

                    <div>Destinatarios</div>

                    <div>Estado</div>

                    <div>Acciones</div>

                </div>

                {filtered.length === 0 && (

                    <div className="history-empty">

                        <i className="fa-solid fa-envelope-open"></i>

                        <h3>

                            Todavía no has enviado campañas

                        </h3>

                        <p>

                            Cuando envíes un correo aparecerá aquí.

                        </p>

                    </div>

                )}

                {filtered.map(campaign => (

                    <div
                        key={campaign.id}
                        className="history-row"
                    >

                        <div>

                            <strong>

                                {campaign.subject}

                            </strong>

                            {campaign.attachments > 0 && (

                                <span className="attachment">

                                    <i className="fa-solid fa-paperclip"></i>

                                    {campaign.attachments}

                                </span>

                            )}

                        </div>

                        <div>

                            {campaign.date}

                        </div>

                        <div>

                            {campaign.sent}/{campaign.total}

                        </div>

                        <div>

                            <span className="status success">

                                Enviado

                            </span>

                        </div>

                        <div className="actions">

                            <button>

                                <i className="fa-solid fa-eye"></i>

                            </button>

                            <button>

                                <i className="fa-solid fa-copy"></i>

                            </button>

                        </div>

                    </div>

                ))}

            </div>

        </div>

    );

}